module.exports = __webpack_public_path__ + "img/img_3.4ef2f63a.jpg";